import React from 'react';
import { Turnstile } from '@marsidev/react-turnstile';

/**
 * Reusable Cloudflare Turnstile widget component
 * Provides invisible bot protection for forms
 * 
 * @param {function} onSuccess - Callback when verification succeeds, receives token
 * @param {function} onError - Callback when verification fails
 * @param {string} action - Optional action name for analytics (e.g., 'login', 'checkout')
 */
export default function TurnstileWidget({ onSuccess, onError, action = 'submit' }) {
    // Use test keys in development to avoid "domain not allowed" errors
    const isDev = process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost';
    const siteKey = isDev ? '1x00000000000000000000AA' : process.env.REACT_APP_CLOUDFLARE_TURNSTILE_SITE_KEY;

    if (!siteKey) {
        console.warn('Cloudflare Turnstile site key not configured');
        return null;
    }

    return (
        <Turnstile
            siteKey={siteKey}
            onSuccess={onSuccess}
            onError={onError}
            options={{
                action,
                theme: 'light',
                size: 'normal',
                execution: 'render', // Can be 'render' or 'execute'
            }}
        />
    );
}
